import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import VisitUs from "../components/VisitUs";
import { gsap } from "gsap";
import { useNavigate } from "react-router-dom";

export default function Overview() {
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("RESIDENTIAL");

  useEffect(() => {
    let mm = gsap.matchMedia();
    mm.add("(min-width: 800px)", () => {
      gsap
        .to("#topic1", {
          position: "fixed",
          top: "25vh",
          marginTop: "0px",
          duration: 0,
          scrollTrigger: {
            start: 1950,
            trigger: "#intro",
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
      gsap
        .to("#topic2", {
          position: "fixed",
          top: "35vh",
          duration: 0,
          scrollTrigger: {
            start: 2370,
            trigger: "#topic2",
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
      gsap
        .to("#topic3", {
          position: "fixed",
          top: "45vh",
          duration: 0,
          scrollTrigger: {
            start: 2820,
            trigger: ".description",
            // pin: true,
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
      gsap
        .to("#topic4", {
          position: "fixed",
          top: "55vh",
          duration: 0,
          scrollTrigger: {
            start: 3350,
            trigger: "#topic4",
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();

      gsap
        .to("#topic5", {
          position: "fixed",
          top: "65vh",
          duration: 0,
          scrollTrigger: {
            start: 3750,
            trigger: "#topic5",
            // pin: true,
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();

      gsap
        .to(".topic", {
          opacity: 0,
          duration: 0.25,
          scrollTrigger: {
            start: 4400,
            trigger: "#topic4",
            // pin: true,
            end: 2600,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
    });
  }, []);

  const dispatch = useDispatch();
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/AGIS (4).jpeg") +
              "')",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textAlign: "center",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Admissions in ASPIRE Grove International Pre-School, Devanahalli
            Premium International Pre-School
          </div>
        </div>
        <div
          style={{
            padding: state.auth.isMobile
              ? "100px 10% 100px 10%"
              : "100px 20% 100px 20%",
          }}
        >
          <Grid container spacing={5}>
            <Grid item xs={12} md={8}>
              <div
                style={{
                  fontSize: "35px",
                  fontWeight: "600",
                  textAlign: "left",
                }}
              >
                One School. Many Possibilites.
              </div>

              <p>
                ASPIRE Grove International Pre-School, Devanahalli Premium
                International Pre-School educates academically talented students
                to become state, national, and global leaders in science,
                technology, engineering, and mathematics. Founded as the
                nation’s first public, residential STEM high school, we let
                North Carolina students design your future through challenging
                programs driven by instructional excellence and the excitement
                of discovery.
              </p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <Button
                onClick={() => {
                  navigate("/admission_form");
                }}
                style={{
                  border: "2px #005a32 solid",
                  borderRadius: "35px",
                  width: "100%",
                  height: "60px",
                  fontSize: "18px",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  backgroundColor: "#005a32",
                  fontFamily: "Montserrat",
                }}
              >
                Apply Now
              </Button>
              <br />
              <Button
                onClick={() => {
                  navigate("/register");
                }}
                style={{
                  border: "2px #d7301f solid",
                  borderRadius: "35px",
                  width: "100%",
                  height: "60px",
                  fontSize: "18px",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  backgroundColor: "#d7301f",
                  fontFamily: "Montserrat",
                }}
              >
                Register
              </Button>

              <Button
                onClick={() => {
                  navigate("/about_school");
                }}
                style={{
                  border: "2px #4a1486 solid",
                  borderRadius: "35px",
                  width: "100%",
                  height: "60px",
                  fontSize: "18px",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  backgroundColor: "#4a1486",
                  fontFamily: "Montserrat",
                }}
              >
                About us
              </Button>
            </Grid>
          </Grid>
        </div>
        <div style={{ backgroundColor: themeStyle.primaryColor }}>
          <div style={{ padding: "100px 50px 100px 50px" }}>
            <Grid container spacing={1}>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <div
                  style={{
                    fontSize: "45px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  Explore Our Programs
                </div>
                {/* <Grid
                  container
                  spacing={10}
                  style={{
                    marginTop: "0px",
                  }}
                >
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <Button
                      onClick={() => {
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                        setSelectedTab("RESIDENTIAL");
                      }}
                      style={{
                        border:
                          selectedTab == "RESIDENTIAL"
                            ? "2px solid " + themeStyle.secondaryButtonColor
                            : "2px solid #ddd",
                        borderRadius: "35px",
                        width: "100%",
                        height: "60px",
                        fontSize: "18px",
                        color:
                          selectedTab == "RESIDENTIAL"
                            ? themeStyle.primaryColor
                            : themeStyle.secondaryButtonColor,
                        fontWeight: "bold",
                        marginBottom: "25px",
                        backgroundColor:
                          selectedTab == "RESIDENTIAL"
                            ? themeStyle.secondaryButtonColor
                            : themeStyle.primaryColor,
                        fontFamily: "Montserrat",
                      }}
                    >
                      RESIDENTIAL
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <Button
                      onClick={() => {
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                        setSelectedTab("VIRTUAL");
                      }}
                      style={{
                        border:
                          selectedTab == "VIRTUAL"
                            ? "2px solid " + themeStyle.secondaryButtonColor
                            : "2px solid #ddd",
                        borderRadius: "35px",
                        width: "100%",
                        height: "60px",
                        fontSize: "18px",
                        color:
                          selectedTab == "VIRTUAL"
                            ? themeStyle.primaryColor
                            : themeStyle.secondaryButtonColor,
                        fontWeight: "bold",
                        marginBottom: "25px",
                        backgroundColor:
                          selectedTab == "VIRTUAL"
                            ? themeStyle.secondaryButtonColor
                            : themeStyle.primaryColor,
                        fontFamily: "Montserrat",
                      }}
                    >
                      VIRTUAL
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <Button
                      onClick={() => {
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                        setSelectedTab("SUMMER");
                      }}
                      style={{
                        border:
                          selectedTab == "SUMMER"
                            ? "2px solid " + themeStyle.secondaryButtonColor
                            : "2px solid #ddd",
                        borderRadius: "35px",
                        width: "100%",
                        height: "60px",
                        fontSize: "18px",
                        color:
                          selectedTab == "SUMMER"
                            ? themeStyle.primaryColor
                            : themeStyle.secondaryButtonColor,
                        fontWeight: "bold",
                        marginBottom: "25px",
                        backgroundColor:
                          selectedTab == "SUMMER"
                            ? themeStyle.secondaryButtonColor
                            : themeStyle.primaryColor,
                        fontFamily: "Montserrat",
                      }}
                    >
                      SUMMER
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <Button
                      onClick={() => {
                        dispatch({
                          type: "NAV_COLOR",
                          payload: {
                            navColor: themeStyle.secondaryButtonColor,
                            navOpacity: 1,
                          },
                        });
                        setSelectedTab("NOT SURE");
                      }}
                      style={{
                        border:
                          selectedTab == "NOT SURE"
                            ? "2px solid " + themeStyle.secondaryButtonColor
                            : "2px solid #ddd",
                        borderRadius: "35px",
                        width: "100%",
                        height: "60px",
                        fontSize: "18px",
                        color:
                          selectedTab == "NOT SURE"
                            ? themeStyle.primaryColor
                            : themeStyle.secondaryButtonColor,
                        fontWeight: "bold",
                        marginBottom: "25px",
                        backgroundColor:
                          selectedTab == "NOT SURE"
                            ? themeStyle.secondaryButtonColor
                            : themeStyle.primaryColor,
                        fontFamily: "Montserrat",
                      }}
                    >
                      NOT SURE
                    </Button>
                  </Grid>
                </Grid> */}
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "0px 10% 100px 10%",
            }}
          >
            <div style={{ color: "white" }}>
              <div style={{ fontSize: "35px", fontWeight: "600" }}>
                Infants from 1.5 years to 2 years and Toddlers from 2 years to 3
                years
              </div>
              <br />
              <b>Early Years</b> <br /> <br /> 1.Foundational Early Stage 1 – 3
              to 4 years
              <br /> <br /> 2.Foundational Early Stage 2 – 4 to 5 years <br />{" "}
              <br />
              3.Foundational Early Stage 3 – 5 to 6 years <br /> <br />
              Camps and Afternoon Care services
            </div>
          </div>
        </div>
        <div className="aboutabout2">
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 1: Admission Policy – Aim */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Admission Policy – Aim
            </div>
            <br />
            The aim of the Admissions Policy is to give clear guidance on the
            admissions process.
            <br />
            <br />
            We welcome children from all origins, backgrounds, and special
            needs.
            <br />
            <br />
            We accept children of ages 1.5 to 5 years.
            <br />
            <br />
            We have 5 days and 6 days learning programme and extended day care
            services.
            <br />
            <br />
            Admissions to the nursery will be conducted on a first come first
            served basis in a fair manner. Siblings are given priority for
            admission.
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 2: Admissions Procedure */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Admissions Procedure
            </div>
            <br />
            A visit or tour is arranged with a senior member of the staff, to
            show prospective families around, answering any questions they have.
            <br />
            <br />
            An ‘expression of interest’ will be shared by the family giving
            details of the days and times they would like their child to attend.
            <br />
            <br />
            Where possible we aim to provide preferred session times or provide
            alternative days/ times if these are not available.
            <br />
            <br />
            On confirmation, the enrolment form is shared with parents.
            <br />
            <br />
            The child’s confidential contact information, medical records and
            other important information will be gathered and securely stored
            before the start date.
            <br />
            <br />A non-refundable Admission Fee is collected at the time of
            registration.
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 3: Admission Documents */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Admission Documents
            </div>
            <br />
            <ul>
              <li>Registration Form (Click to Download)</li>
              <li>Medical and Consent Form</li>
              <li>2 Passport Photos</li>
              <li>Copy of Parents and Child’s Passport Including</li>
              <li>Copy of Birth Certificate of the child</li>
              <li>Adhar Card Copy (FMC)</li>
              <li>Enquiry Form</li>
              <li>Parent Info</li>
            </ul>
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 4: Communications */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Communications
            </div>
            <br />
            Effective communication builds trust and understanding. We believe
            that parents are the primary educators of their children and should
            be centrally involved in their child’s learning experiences and
            development.
            <br />
            <br />
            We use an online platform called ‘Edubricz’ where parents can log on
            and see their children’s development as soon as they are uploaded.
            Each child has a learning profile which is a record of the child’s
            interests, significant achievements and development throughout their
            time with us. Teachers upload photos, videos and important
            information regularly to maintain transparent and clear
            communication lines.
            <br />
            <br />
            Parent teacher conferences are held thrice in a year, where you can
            meet the teacher to discuss your child’s progress or share important
            information.
            <br />
            <br />
            You are welcome to contact us at any time and look forward to
            working in partnership with you.
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 5: Age Eligibility */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Age Eligibility
            </div>
            <br />
            We accept children from 1.5 to 5 years.
            <br />
            <br />
            Children 3 years and above, as on 31 May of the relevant academic
            year are eligible for FES1 and must opt for the 5-day attendance
            schedule while children, as on 31 May of the relevant academic year
            are eligible for FES2.
            <br />
            <br />
            Based on teachers’ observation and assessment, if a child is deemed
            ready for the next class within the academic year, the promotion may
            be considered in consultation with the parent and the national
            policy.
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 6: Uniform */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Uniform
            </div>
            <br />
            Wearing a uniform fosters a sense of belonging and teaches children
            to take pride in their appearance. It is put in place to ensure
            children are dressed appropriately for their daily activities.
            Uniform consists of track pants and a T shirt. Winter uniform
            consists of a jacket.
            <br />
            <br />
            Children should wear comfortable footwear that will allow them to
            run and climb safely. We also ask children to wear socks daily.
            <br />
            <br />
            Girls’ hair to be neatly tied. We request parents to keep gold or
            expensive jewellery to a minimum and use small ear studs instead.
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 7: Transport */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Transport
            </div>
            <br />
            We are happy to provide a door-to-door bus service for children from
            our surrounding areas. We adhere to stringent safety standards and
            to the Road Transport Authority of Karnataka, standards and
            regulations.
            <br />
            <br />
            Transport service is available on a first come first served basis
            and availability of seat. A female bus attendant is always present
            in the bus. Parents are requested to be on the designated pick and
            drop off point 5 minutes before scheduled time.
            <br />
            <br />
            The bus attendant will hand over the child only to the person
            authorized to do so in the enrolment form.
            <br />
            <br />
            Locations – Devanahalli , Vijayapura
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 8: Join Our Fun Class */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Join Our Fun Class with other Classmates
            </div>
            <br />
            Embark on an educational journey filled with laughter, learning, and
            love at our nurturing nursery. Our dedicated team is ready to
            provide your child with a foundation for lifelong success. Don’t
            wait; join our vibrant community and watch your child flourish!
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 10: Child protection and Safeguarding Policy */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Child Protection and Safeguarding Policy - Introduction and Aim
            </div>
            <br />
            It is our aim to ensure that all children receive the highest level
            of care, provision, and education. The health, safety, and welfare
            of our children are of paramount importance. Therefore, our prime
            responsibility is the welfare and well-being of children, and all
            staff will work as a team in the best interest of the child.
            <br />
            <br />
            Procedure
            <br />
            <br />
            All signs of marks/injuries to a child, when they come into the
            setting or occur during their time here, will be recorded as soon as
            noticed by a staff member. The incident will be discussed with the
            parent at the earliest opportunity, where felt appropriate.
            <br />
            <br />
            For more serious marks, the manager should maintain a record of
            <br />
            <br />
            <ul>
              <li>Child’s name and address</li>
              <li>Child’s age and date of birth</li>
              <li>Date and time of the observation or the disclosure</li>
              <li>Exact words spoken by the child</li>
              <li>Exact position and type of injuries or marks seen</li>
              <li>
                Name of the person to whom the concern was reported, with date
                and time.
              </li>
            </ul>
            Any discussion held with the parent(s)
            <br />
            <br />
            All records will be kept confidential. We endeavour to be sensitive
            to all involved in any child protection issues and to discuss
            concerns on a need-to-know basis to maintain confidentiality.
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-100px" }}>
          <div
            style={{
              width: "90%",
              textAlign: "justify",
              marginTop: "-150px",
              paddingBottom: "50px",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            {/* Section 11: Arrival and Departure Policy */}
            <div
              style={{
                fontSize: "32px",
                fontFamily: "Montserrat",
                textAlign: "left",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontWeight: "bold",
              }}
            >
              Arrival and Departure Policy - Introduction and Aim
            </div>
            <br />
            AGIS always gives a warm welcome to children, parents and visitors
            on their arrival. All visitors will be asked to sign in the register
            kept at the reception and identify their purpose of visit.
            <br />
            <br />
            Procedure
            <br />
            <br />
            The child should be handed over to the reception staff before the
            parent leaves the setting. This ensures that the staff is aware of
            who has arrived.
            <br />
            <br />
            Parents will not be allowed beyond the reception gate.
            <br />
            <br />
            A child’s medication needs should be passed on to reception staff
            verbally and should be written in the register.
            <br />
            <br />
            Parents are to advise the AGIS in advance if someone else is picking
            up their child. Written authorization by the parent as well as the
            ID as proof of identity will be required.
            <br />
            <br />
            In case school transportation is used, please ensure that you are
            present at the pickup and drop off area when the bus arrives. The
            bus will wait no more than 5 minutes to pick or drop the child.
          </div>
        </div>
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
